import { Box, Divider, Grid, Link, Stack, Typography } from '@mui/material';
import { DataFiscal, Logo } from '../../assets';
import { COLORS } from '../../constants';
import { Transition } from '../transition';

/**
 * Renders a reusable footer component that is displayed across every app.
 *
 * @return {React.JSX.Element} The rendered footer component.
 */
export const Footer = ({ showText }: { showText: boolean }) => (
  <Box sx={{ overflow: 'hidden' }} data-testid="footer">
    <Transition type="fadeUp">
      <Box
        component="footer"
        sx={{
          backgroundColor: { xs: 'transparent', md: 'background.paper' },
          px: { xs: 2, md: 8 },
          width: '100vw',
          py: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}
      >
        <Grid
          sx={{
            display: 'flex',
            flexDirection: { xs: 'row', md: 'column' },
            gap: 4,
            justifyContent: 'space-between',
          }}
        >
          <Stack direction="column" gap={2}>
            <Grid sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Logo type="small" height={48} />
            </Grid>
            <Stack direction={{ xs: 'column', md: 'row' }} gap={{ xs: 2, md: 4 }} sx={{ color: 'primary.main' }}>
              {/* @todo: Links will be props */}
              {/* <Link variant="body2" href="https://www.directo.com.ar/contacto" target="_blank" rel="noreferrer">
                Contacto
              </Link> */}
              <Link
                variant="body2"
                href="https://www.directo.com.ar/preguntas-frecuentes"
                target="_blank"
                rel="noreferrer"
              >
                Preguntas frecuentes
              </Link>
              <Link
                variant="body2"
                href="https://www.directo.com.ar/politicas-de-privacidad"
                target="_blank"
                rel="noreferrer"
              >
                Políticas de privacidad
              </Link>
              <Link
                variant="body2"
                href="https://www.directo.com.ar/terminos-y-condiciones-de-directo/"
                target="_blank"
                rel="noreferrer"
              >
                Términos y condiciones
              </Link>
              <Link
                variant="body2"
                href="https://www.directo.com.ar/informacion-al-usuario-financiero"
                target="_blank"
                rel="noreferrer"
              >
                Información al usuario financiero
              </Link>
            </Stack>
          </Stack>
          <Divider />
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            gap={{ xs: 2, md: 4 }}
            justifyContent={{ xs: 'space-between', md: 'flex-end' }}
            alignItems="flex-end"
          >
            <Stack sx={{ textAlign: 'right', justifyContent: 'center', color: COLORS.text.light2 }}>
              <Typography fontFamily="sans-serif" variant="caption">
                Crédito Directo S.A. – CUIT N° 30-71210113-6
              </Typography>
              <Typography fontFamily="sans-serif" variant="caption">
                Tte. Gral. Juan Domingo Perón 646, Piso 4°
              </Typography>
              <Typography fontFamily="sans-serif" variant="caption">
                Ciudad Autónoma de Buenos Aires
              </Typography>
            </Stack>
            <DataFiscal />
          </Stack>
        </Grid>
        {showText && <Divider />}
        {showText && (
          <Box textAlign="justify">
            <Typography fontFamily="sans-serif" variant="caption" color={COLORS.text.light2}>
              Cartera de consumo. El monto mínimo de financiación es de $1.000 y el monto máximo de $4.000.000. El
              período mínimo para la devolución de un préstamo es de 3 meses y el máximo 12 meses. El otorgamiento del
              préstamo está sujeto a evaluación crediticia de Crédito Directo S.A. CUIT: 30712101136. Tipo de
              Amortización: Francés, cuotas mensuales, consecutivas y a Tasa Fija. El Costo Financiero Total Efectivo
              Anual es orientativo y de carácter informativo. Ejemplo de préstamo online realizado desde el sitio web
              efectivo.directo.com.ar: Monto solicitado de $4.000.000 a 12 meses, TNA MÁX 190,0%, TEA MÁX 483,45% y el
              CFTTEA MÁX es 585% (IVA INCLUIDO). La cuota promedio será de $764.336 devolviendo un total de $9.172.032
              al final del crédito. En todos los casos, la Tasa Nominal Anual (TNA), la Tasa Efectiva Anual (TEA) y el
              Costo Financiero Total Efectivo Anual (CFTTEA) aplicables serán informados antes de la aceptación de la
              oferta de préstamo por parte del solicitante.
            </Typography>
          </Box>
        )}
      </Box>
    </Transition>
  </Box>
);
